import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { useLocalSearchParams } from 'expo-router';
import { conversationHomeModuleQuery } from 'system/structure-modules';

export default function ConversationHomeLayout() {
    const { siloKey } = useLocalSearchParams<'/[siloKey]'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'conversation-home',
        instanceKey: 'one',
        moduleQuery: conversationHomeModuleQuery,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceStack />
        </DatastoreProvider>
    );
}
